import store from "@/store";
import { httpClient } from "./http-client";

export default class ApiService {
  async get_view_data(req) {
    return httpClient({
      url: `qc/view/${req.id}/initial/${req.query ? `?${req.query}` : ""}`,
      baseURL: store.state.api_host,
      headers: req.headers,
    });
  }
  async get_project_orthotiles_meta(req = "") {
    return httpClient({
      url: req.url,
    });
  }
  async get_features(req = "") {
    return httpClient({
      url: req,
    });
  }
  async get_config(req) {
    return httpClient({
      url: req.terra
        ? `qc/view/${req.id}/config`
        : `viewer/view/${req.id}/config/`,
      baseURL: store.state.api_host,
      headers: req.headers,
    });
  }
  async save_features(req) {
    return httpClient({
      url: `qc/projects/${req.id}/`,
      baseURL: store.state.api_host,
      method: "post",
      data: req.body,
      headers: req.headers,
    });
  }
  async post_project_status(req) {
    return httpClient({
      url: `qc/projects/${req.id}/statuses`,
      baseURL: store.state.api_host,
      method: "post",
      data: req.body,
      headers: req.headers,
    });
  }
  async get_project_status(req) {
    return httpClient({
      url: `qc/projects/${req.id}/statuses`,
      baseURL: store.state.api_host,
      headers: req.headers,
    });
  }
  async get_data(req) {
    return httpClient({
      url: req.url,
    });
  }
  async scm_train_data(req) {
    return httpClient({
      baseURL: process.env.VUE_APP_SCM_TRAIN_API_HOST,
      url: "train",
      method: "post",
      data: req.body,
    });
  }
  async post_data(req) {
    return httpClient({
        url: req.url,
        method: 'post',
        data: req.body,
        headers: req.headers
    })
}
  async get_models_list(req) {
    return httpClient({
      baseURL: process.env.VUE_APP_SCM_INFERENCE_API_HOST,
      url: `list-models${req.query ? `?${req.query}` : ""}`,
    });
  }
  async scm_predict(req) {
    return httpClient({
      baseURL: process.env.VUE_APP_SCM_INFERENCE_API_HOST,
      url: `predict?no_token`,
      method:"POST",
      data: req.body,
    });
  }
  async get_report_download_link(req) {
    return httpClient({
      url: req.url,
    });
  }
  async get_claims() {
    return httpClient({
      url: "claims",
      baseURL: process.env.VUE_APP_CORE_API_HOST,
    });
  }
}
